import React, {forwardRef, useImperativeHandle, useState} from "react";
import {Modal} from "antd";
import {IconClose} from "../../Icon";
import {t} from "i18next";
import {ipcSend} from "@/common/ipc";
import {isZh} from "@/language";

let mExportEvent:any = null;
const DialogExportTips = forwardRef((props, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);

    const onShowDialog = (exportEvent:any)=>{
        mExportEvent = exportEvent;
        setIsShowDialog(true);
    }

    return(
        <Modal closeIcon={<IconClose/>} open={isShowDialog} width={'468px'} bodyStyle={{height:'300px'}}
               centered={true} footer={''} onCancel={(e)=>setIsShowDialog(false)}>
            <div className={'flex-column-center'}>
                <span style={{marginTop:'36px'}} className={'mt-16'}>{t("YouNeedToUpgrade")}</span>
                <div style={{width:'164px',marginTop:'26px'}} className={'button-solid-style flex-center'} onClick={()=>{
                    if (isZh()) {
                        ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICEZ_ZH);
                    }else {
                        ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                    }
                }}>{t("Get more")}</div>

                <div style={{width:'100%',margin:'28px -22px',position:'relative'}} className={'line'}>
                    <span style={{position:'absolute',display:'block', left:'50%',padding:'0 8px',transform:'translate(-50%,-50%)',
                        background:'var(--dialog-background-color)'}}>{t("Or").toUpperCase()}</span>
                </div>

                <span>{t("ExportProjectForBackup")}</span>

                <div style={{width:'164px',marginTop:'26px'}} className={'button-border-gray-style flex-center'} onClick={()=>{
                    setIsShowDialog(false);
                    if(mExportEvent) {
                        mExportEvent();
                    }
                }}>{t("Export")}</div>
            </div>
        </Modal>
    )
});

export default React.memo(DialogExportTips);